var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-box"},[_c('FormCom',{attrs:{"form":[{
      name: '',
      value: '',
      type: 'YourselfDiy',
      props: {},
    }]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }